import { ShortBody } from 'components/Typography';
import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  && {
    background-color: #0075c9;
    padding: 22px 0px;
  }
`;

const StyledTag = styled.a`
  text-decoration: none;
`;

const StyledShortBody = styled(ShortBody)`
  && {
    color: #fff;
    margin: 0;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const StyledAllRightResevedText = styled(ShortBody)`
  && {
    color: #fff;
    margin: 0;
  }
`;

const FooterText = styled(StyledShortBody)`
  && {
    text-align: center;
    text-decoration: none;
  }
`;

const StyledImg = styled.img`
  margin-top: 3px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

const FbStyledIncon = styled(({ reverse, ...otherProps }) => (
  <StyledImg {...otherProps} />
))`
  && {
    margin-right: ${(props) => (props.reverse ? '0px' : '27px')};
    margin-left: ${(props) => (props.reverse ? '27px' : '0px')};
    margin-bottom: 2px;
  }
`;

export {
  FooterWrapper,
  StyledShortBody,
  StyledImg,
  FooterText,
  FbStyledIncon,
  StyledAllRightResevedText,
  StyledTag,
};
